"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Registration {
    constructor(_filterFn, _callbackFn) {
        this._filterFn = _filterFn;
        this._callbackFn = _callbackFn;
        // Nothing Here
    }
    onNotification(notificationModel) {
        if (this._filterFn(notificationModel)) {
            this._callbackFn(notificationModel);
        }
    }
}
exports.Registration = Registration;
class NotificationServiceImplBase {
    constructor(dispatcher) {
        this.dispatcher = dispatcher;
        this._handlers = {};
        this.dispatcher.registerNotificationHandler(this.onNotification.bind(this));
    }
    registerHandler(id, filterFn, handler) {
        const handlers = this._handlers[id] || new Array();
        const registration = new Registration(filterFn, handler);
        handlers.push(registration);
        this._handlers[id] = handlers;
        return () => this.removeRegistration(id, registration);
    }
    hasHandlersForNotificationType(id) {
        // eslint-disable-next-line no-prototype-builtins
        return this._handlers.hasOwnProperty(id);
    }
    onNotification(notification) {
        if (!this.hasHandlersForNotificationType(notification.notificationId)) {
            return;
        }
        // Go through and check for all the handlers of this particular notification
        this._handlers[notification.notificationId].forEach((h) => h.onNotification(notification.data));
    }
    removeRegistration(id, registration) {
        if (!this.hasHandlersForNotificationType(id)) {
            return;
        }
        this._handlers[id] = this._handlers[id].filter((reg) => reg !== registration);
    }
}
exports.NotificationServiceImplBase = NotificationServiceImplBase;
//# sourceMappingURL=NotificationServiceImplBase.js.map